import { Chart as ChartJS } from 'chart.js';

/**
 * Dynamic buffer line plugin.
 * @param getBufferValues - Getter that returns current scaled buffer values on each draw.
 *                          Chart.js doesn't re-register plugins after creation, so we read
 *                          from a getter/ref to always get the latest values.
 */
export const dynamicBufferLinePlugin = (getBufferValues: () => number[]) => {
  return {
    id: 'bufferLine',
    afterDraw: (chart: ChartJS) => {
      const {
        ctx,
        chartArea: { left, right },
        scales: { y, x },
      } = chart;

    // Draw dynamic buffer line (dashed red line connecting monthly buffer values)
    const bufferValues = getBufferValues();
    const dataPoints: Array<{ x: number; y: number }> = [];
    
    bufferValues.forEach((val, index) => {
      if (val > 0) {
        const xPos = x?.getPixelForValue(index);
        const yPos = y?.getPixelForValue(val);
        if (xPos !== undefined && yPos !== undefined) {
          dataPoints.push({ x: xPos, y: yPos });
        }
      }
    });
    
    // Draw the buffer line connecting the points
    if (dataPoints.length > 0 && y) {
      ctx.save();
      ctx.strokeStyle = '#EF4444';
      ctx.lineWidth = 2;
      ctx.setLineDash([5, 5]);
      ctx.beginPath();
      
      dataPoints.forEach((point, index) => {
        if (index === 0) {
          ctx.moveTo(point.x, point.y);
        } else {
          ctx.lineTo(point.x, point.y);
        }
      });
      
      ctx.stroke();

      // Add label at the last point
      const lastPoint = dataPoints[dataPoints.length - 1];
      ctx.fillStyle = '#EF4444';
      ctx.font = '12px sans-serif';
      ctx.fillText('Buffer Stock', lastPoint.x - 80, lastPoint.y - 8);
      ctx.restore();
    }

    // Draw emphasized zero line
    const zeroYPosition = y?.getPixelForValue(0);
    if (zeroYPosition) {
      ctx.save();
      ctx.strokeStyle = '#374151';
      ctx.lineWidth = 1;
      ctx.setLineDash([]);
      ctx.beginPath();
      ctx.moveTo(left, zeroYPosition);
      ctx.lineTo(right, zeroYPosition);
      ctx.stroke();
      ctx.restore();
    }
    },
  };
};
